<template>
  <aside>
    <div class="titulo margem efeito">
      <div class="m-icone"><a href="#" class="icone-menu" title="Menu"
          onclick="document.getElementById('main').classList.toggle('esconde');return false"></a></div>
      <nav class="jm jm-inc none" id="menuIncluir">
        <div class="separador">
          <a href="#">Incluir projeto</a>
          <a href="monitoramento.html">Incluir projeto</a>
        </div>
      </nav>
    </div>
    <nav class="nav-maior separador">
      <!-- <router-link to="/" active-class="ativo">Acesso</router-link>
      <router-link to="/visitante/" active-class="ativo">Visitante</router-link> -->
      <!-- <router-link to="/solicitacao-visita/novo" active-class="ativo">Cadastrar visita</router-link> -->
      <router-link to="/" active-class="ativo">Agendar Visita</router-link>
      <router-link v-if="permissoes.includes(256)" :to="{ name: 'ListaCheckinDia' }" active-class="ativo">Registros do dia</router-link>
      <div v-if="permissoes.includes(256)" class="menu-relatorios">
        <button type="button" class="menu-relatorios-cabeca" :class="{ ativo: relatoriosTemRotaAtiva }"
          :aria-expanded="relatoriosAberto" aria-controls="submenu-relatorios" id="btn-submenu-relatorios"
          @click="relatoriosAberto = !relatoriosAberto">
          <span>Relatórios</span>
          <i class="fa-solid fa-chevron-down menu-relatorios-seta"
            :class="{ 'menu-relatorios-seta--aberto': relatoriosAberto }" aria-hidden="true"></i>
        </button>
        <div v-show="relatoriosAberto" id="submenu-relatorios" class="menu-relatorios-itens" role="region"
          aria-labelledby="btn-submenu-relatorios">
          <router-link to="/solicitacoes" active-class="ativo">Solicitações de visita</router-link>
          <router-link to="/visitantes" active-class="ativo">Todos os visitantes</router-link>
        </div>
      </div>
      <!-- <router-link to="/pesquisa" active-class="ativo">Pesquisa / Relatório</router-link>
      <router-link to="/colaboradores" active-class="ativo">Envio de QR Code</router-link> -->
      <!-- <router-link to="/colaboradores-rh" active-class="ativo">Colaborador RH</router-link> -->
    </nav>
    <nav class="nav-maior separador">
      <router-link to="/anfitriao/meus-pedidos" active-class="ativo">Minhas Solicitações </router-link>
    </nav>
  </aside>
</template>
<script>
import { sso } from "roboflex-thalamus-sso-lib";
import { getPermissao } from "@/services/permissaoService";

export default {
  name: "NovoMenuLateral",

  data() {
    return {
      relatoriosAberto: false,
      permissoes: [],
    };
  },

  computed: {
    relatoriosTemRotaAtiva() {
      const p = this.$route.path || "";
      return (
        p === "/solicitacoes" ||
        p.startsWith("/solicitacoes/") ||
        p === "/visitantes" ||
        p.startsWith("/visitantes/")
      );
    },
  },

  async created() {
    this.permissoes = await getPermissao();
  },

  watch: {
    relatoriosTemRotaAtiva: {
      handler(v) {
        if (v) this.relatoriosAberto = true;
      },
      immediate: true,
    },
  },

  methods: {
    sair() {
      sso.logout();
      const url = (process.env.VUE_APP_ROOT_SSO_LOGIN || "").trim();
      window.location.href =
        url ||
        (process.env.NODE_ENV === "production"
          ? "https://portal.thalamus.ind.br/#/login"
          : "http://portal-homologacao.thalamus.ind.br/#/login");
    },

    estrutura() {
      this.$router.push("/estrutura");
    },

    associar() {
      this.$router.push("/associar");
    },
    cadastrar() {
      this.$router.push("/cadastrar/orcamento/manual");
    },
    relatorio() {
      this.$router.push("/relatorio/orcamento");
    },
    orcamento() {
      this.$router.push("/orcamentos");
    },
  },
};
</script>
<style scoped>
.menu-relatorios {
  border-top: 0;
}

.menu-relatorios-cabeca {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 13px var(--margem, 24px);
  border: none;
  background: transparent;
  font: inherit;
  font-size: inherit;
  color: var(--cor-fonte, rgba(0, 0, 0, 0.85));
  text-align: left;
  cursor: pointer;
}

.menu-relatorios-cabeca:hover {
  color: var(--cor-primaria-forte);
}

.menu-relatorios-cabeca.ativo {
  color: var(--cor-primaria-forte);
  font-weight: 600;
}

.menu-relatorios-seta {
  font-size: 0.65rem;
  opacity: 0.75;
  transition: transform 0.2s ease;
}

.menu-relatorios-seta--aberto {
  transform: rotate(180deg);
}

.menu-relatorios-itens {
  display: flex;
  flex-direction: column;
}

.menu-relatorios-itens a {
  padding: 10px var(--margem, 24px) 10px calc(var(--margem, 24px) + 12px);
}
</style>
